// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"9e1b3f65","268":"310c3786","462":"dcf8fb61","551":"c9964f56","842":"06dd85e3","950":"86e69b26"}[chunkId] + ".chunk.js";
};